import { z } from 'zod'
import { tagSchema } from '../tags/TTag'
import { Pagination } from '../helper'

export const loraDeviceListItemSchema = z.object({
  deviceId: z.string(),
  eui: z.string(),
  appEUI: z.string(),
  appKey: z.string().nullish(),
  isOnline: z.boolean(),
  lastSeenAt: z.string().nullable(),
  name: z.string().nullable(),
  provider: z.string().nullable(),
  tags: z.array(tagSchema).nullable(),
  organization: z
    .object({
      id: z.string(),
      name: z.string().nullable(),
    })
    .nullable(),
  deviceGroups: z
    .array(
      z.object({
        id: z.string().nullable(),
        name: z.string().nullable(),
        description: z.string().nullable(),
        locationId: z.string().nullable(),
        countDevice: z.number().nullable(),
      }),
    )
    .nullable(),
})

export type TLoraDeviceListItem = z.infer<typeof loraDeviceListItemSchema>

export type TLoraDeviceList = Pagination<TLoraDeviceListItem>
